import { bootSupport } from "./supportBoot";
import SupportApp from "./SupportApp";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
bootSupport().then(active => root.render(active ? <SupportApp /> : <App />)).catch(() => {
  // A failed grant must never fall through to somebody else's ordinary App login.
  const message = document.createElement("p");
  message.textContent = "Prüfzugang ungültig oder abgelaufen. Bitte erneut über das Schülerprofil öffnen.";
  message.style.padding = "32px";
  document.getElementById("root").replaceChildren(message);
});
